import { useState } from 'react';
import { cn } from '@/lib/utils';
import { getInitials } from '@/pages/Votes/components/logo';
import type { JudgeBallotProject } from '@/types';

// The project's logo, or its initials when it has none or the image fails to load.
export function ProjectLogo({
  project,
  className,
}: {
  project: Pick<JudgeBallotProject, 'name' | 'logoUrl'>;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);

  if (!project.logoUrl || failed) {
    return (
      <div
        className={cn(
          'flex shrink-0 items-center justify-center border border-primary/30 bg-primary/10 font-bold text-primary',
          className,
        )}
      >
        {getInitials(project.name)}
      </div>
    );
  }

  return (
    <img
      src={project.logoUrl}
      alt={`Logo de ${project.name}`}
      onError={() => setFailed(true)}
      className={cn(
        'shrink-0 border border-primary/30 bg-white object-contain',
        className,
      )}
    />
  );
}
